import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import { grey } from '@material-ui/core/colors';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, Typography, FormControlLabel, FormLabel} from '@material-ui/core'
import {Button, FormControl, Checkbox, TextField, InputLabel, MenuItem, Select } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import GroupIcon from '@material-ui/icons/Group';

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {RadioGroup, Radio } from '@material-ui/core';

import Chip from '@material-ui/core/Chip';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';

import { isInteger, isNumber } from '../../../api/validators';

class EditProfileDialog_ extends React.Component{

    constructor(props){
        super(props)

        const {profile} = this.props; 

        this.state = {
            profile: {
                Name: profile.ProfileID ? profile.Name : '',
                Description: profile.Description ? profile.Description : '',
                Profile: profile.ProfileID ? {...this.getProfileDefaults(),  ...JSON.parse(profile.Profile)}: {...this.getProfileDefaults()}
            },
            errors:{
                Name: false,
                Description: false,
                ManDownTimeout: false,
                FreeFallThreshold: false,
                ImpactThreshold: false,
                TiltAngle: false
            },
            panelsExpanded:{
                ManDownExteded: false
            },
            changed: false
        }
        console.log('EditProfileDialog_ state')
        console.log(profile)
        console.log(this.getProfileDefaults())
        console.log(this.state)


        this.handleInputProfile = this.handleInputProfile.bind(this)
    }

    getProfileDefaults(Profile){
        return {
            Receivers: [],
            ScreenSOS: false,
            ManDown: false,
            EmergencyVoiceCall: false,
            EmergencyGroupId: null,
            ManDownTimeout: 5,
            ManDownAlgorithm: 0,
            ImpactThreshold: 20,
            FreeFallThreshold: 2,
            TiltAngle: 30
        }
    }


    handleSave(){
        if(this.checkForm()){
            let Profile = JSON.stringify(this.state.profile.Profile);
            let profile = {...this.props.profile, ...this.state.profile, Profile: Profile}
            this.props.onAction({type: 'PROFILE_EDITOR_SAVE', profile: profile})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'PROFILE_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'PROFILE_EDITOR_CLOSE'})
        }
    }   

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}

        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const profile = {...this.state.profile, [event.target.name]: val}

        let err = this.validate(event.target.name, val)
        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        this.setState({profile: profile, ...changed,  ...errors})
    }

    handleInputProfile(event){
        let changed = !this.state.changed ? {changed: true} : {}

        let val =  event.target.type==='checkbox' ? event.target.checked : event.target.value

        console.log(event.target.name)
        console.log(val)

        switch(event.target.name){
            case 'ManDownAlgorithm': val = Number(val); break
            default:
        }

        let err = this.validate(event.target.name, val)
        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        console.log(errors)

        let Profile = {...this.state.profile.Profile, [event.target.name]: val}

        console.log(Profile)

        const profile = {...this.state.profile, Profile: Profile}

        this.setState({profile: profile, ...changed,  ...errors})
    }

    validate(name, value){
        const {t} = this.props
        let error = false

        switch(name){
            case 'Name':
                if(!value) error = this.props.t('NameIsEmpty')
                break

            case 'ManDownTimeout':
            case 'FreeFallThreshold':
            case 'ImpactThreshold':
            case 'TiltAngle':
                if(value && !isNumber(value)){
                    error = t('IsNotNumber')
                }else if(value && !isInteger(value)){
                    error = t('IsNotInteger')
                }
                break

            default:
        }

        return error
    }

    checkForm(){
        console.log('checkform')
        console.log(this.state.profile)
        let check = true
        let errors = {...this.state.errors}
        for(var i in errors){
            let v = null
            let error = false
            if(i==='Name' || i==='Description'){
                v = this.state.profile[i]
            }else{
                v = this.state.profile.Profile[i]
            }
            error = this.validate(i, v)
            errors[i] = error
            if(error) {
                console.error({field: i, value: v, error: error})
                check = false
            }
        }
        this.setState({errors: errors})
        return check
    }

    getReceiverName(ID){
        let receivers = this.props.receivers.filter(item=>item.ID===ID)
        if(receivers.length){
            let icon = this.getReceiverIcon(receivers[0].Type)
             return (<>{icon} {receivers[0].Name}</>)
        }
        return 'undefined '+ID
    }

    getReceiver(ID){
        let receivers = this.props.receivers.filter(item=>item.ID===ID)
        if(receivers.length) return receivers[0]
        return null;
    }

    isReceiverChecked(ID){
        let receivers = this.state.profile.Profile.Receivers.filter(item=>item.ID===ID)
        return receivers.length>0
    }

    handleReceiversChange(event){
        let receivers = []
        console.log(event.target.value)
        for(let i=0; i<event.target.value.length; i++){
            const ID = event.target.value[i]
            const receiver = this.getReceiver(ID)
            if(receiver){
                receivers.push({ID: receiver.ID, Type: receiver.Type})
            }
        }

        let profile = this.state.profile
        profile.Profile.Receivers = receivers;
        this.setState({profile: profile});
    }

    getReceiverType(ID){
        let receiver = this.getReceiver(ID)
        return receiver.Type
    }

    getReceiverIcon(type){
        switch(type){
            case 10: return <PersonOutlineIcon></PersonOutlineIcon>
            case 4: return <GroupIcon></GroupIcon>
            case 3: return <PersonIcon></PersonIcon>
            default: return ''
        }
    }

    togglePanel(event, expanded, panel){

        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })

    }


    render(){
        const {t} = this.props

        const title = this.props.action==='add'?t('NewProfile'):t('EditProfile')

        const margin = {margin:'16px 0 8px 0'}

        //console.log('this.state.profile')
        //console.log(this.state.profile)

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>
            <Box textAlign="">
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="off"
                    error={this.state.errors.Name!==false}
                    value={this.state.profile.Name}
                    onChange={this.handleInput.bind(this)}
                />
            </Box>
            
            <Box textAlign="">
                <TextField name="Description"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Description?this.state.errors.Description:t('Description')}
                    autoComplete="off"
                    error={this.state.errors.Description!==false}
                    value={this.state.profile.Description}
                    onChange={this.handleInput.bind(this)}
                />
            </Box>

            <Box textAlign="">
            <FormControl style={{...margin, width: '100%'}}>
                <InputLabel htmlFor="select-multiple-chip">{t('Receivers')}</InputLabel>
                <Select
                    style={{width: '100%'}}
                    multiple
                    onChange={this.handleReceiversChange.bind(this)}
                    value={this.state.profile.Profile.Receivers.map(item=>item.ID)}
                    input={<Input id="select-multiple-chip" />}
                    MenuProps={{
                        PaperProps: {
                            style: {
                              maxHeight: '20em',
                              width: '100%',
                            },
                          }
                    }}
                    renderValue={selected => (
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                        {selected.map(value => (
                            <Chip key={value} label={this.getReceiverName(value)} style={{margin:2}} />
                        ))}
                        </div>
                    )}
                    
                    >
                    {this.props.receivers.map(item => (
                        <MenuItem key={item.ID} value={item.ID} name={item.Name}>
                            {this.getReceiverIcon(item.Type)}
                            <Checkbox checked={this.isReceiverChecked(item.ID)} />
                            <ListItemText primary={item.Name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.profile.Profile.ScreenSOS}
                            onChange={this.handleInputProfile}
                            name="ScreenSOS"
                            />
                            {t('SosButtonOnTheScreen')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.profile.Profile.EmergencyVoiceCall}
                            onChange={this.handleInputProfile}
                            name="EmergencyVoiceCall"
                            />
                            {t('StartVoiceCallToEmergencyGroup')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="">
            <FormControl style={{...margin, width: '100%'}}>
                <InputLabel htmlFor="EmergencyGroupId">{t('EmergencyGroup')}</InputLabel>
                <Select
                    value={this.state.profile.Profile.EmergencyGroupId}
                    onChange={this.handleInputProfile}
                    inputProps={{
                        name: 'EmergencyGroupId',
                        id: 'EmergencyGroupId',
                    }}
                    >
                    <MenuItem key="0" value={null}></MenuItem>
                    {this.props.emergencyGroups.map(
                        item => <MenuItem key={item.ID} value={item.ID}>{item.Name}</MenuItem>
                    )}
                </Select>
            </FormControl>
            </Box>


            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.profile.Profile.ManDown}
                            onChange={this.handleInputProfile}
                            name="ManDown"
                            />
                            {t('ManDown')}
                    </label>
                </FormControl>
            </Box>
            
            <Box textAlign="">
                <TextField name="ManDownTimeout"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.ManDownTimeout ? (t('ManDownTimeout')+ ': '+ this.state.errors.ManDownTimeout) : t('ManDownTimeout') + ' (' + t('TimeoutBeforeSendingEmergencyOnManDownS') + ')' }
                    autoComplete="off"
                    error={this.state.errors.ManDownTimeout!==false}
                    value={this.state.profile.Profile.ManDownTimeout}
                    onChange={this.handleInputProfile}
                />
                {/*t('TimeoutBeforeSendingEmergencyOnManDownS')*/}
            </Box>
        
        </Container>

        <ExpansionPanel 
                style={{marginTop:20}}
                expanded={this.state.panelsExpanded.ManDownExteded} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, 'ManDownExteded')}>
                <ExpansionPanelSummary style={{backgroundColor2: grey[300]}} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{t('ManDownExtendedProperty')}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block'}}>


                <FormControl component="fieldset">
                    <FormLabel component="legend">{t('ManDownAlgorithm')}</FormLabel>
                    <RadioGroup aria-label="gender" 
                        name="ManDownAlgorithm" 
                        value={this.state.profile.Profile.ManDownAlgorithm} 
                        onChange={this.handleInputProfile}>
                        <FormControlLabel value={0} control={<Radio />} label={t('ManDownUponDeviceFall')} />

                        <Box textAlign="">
                            <TextField name="FreeFallThreshold"  margin="normal"
                                style={{width: '100%'}}
                                label={this.state.errors.FreeFallThreshold ? t('FreeFallThreshold') + ': ' + this.state.errors.FreeFallThreshold : t('FreeFallThreshold')}
                                autoComplete="off"
                                error={this.state.errors.FreeFallThreshold!==false}
                                value={this.state.profile.Profile.FreeFallThreshold}
                                onChange={this.handleInputProfile}
                            />
                        </Box>
                        <Box textAlign="">
                            <TextField name="ImpactThreshold"  margin="normal"
                                style={{width: '100%'}}
                                label={this.state.errors.ImpactThreshold ? t('ImpactThreshold') + ': ' + this.state.errors.ImpactThreshold : t('ImpactThreshold')}
                                autoComplete="off"
                                error={this.state.errors.ImpactThreshold!==false}
                                value={this.state.profile.Profile.ImpactThreshold}
                                onChange={this.handleInputProfile}
                            />
                        </Box>

                        <FormControlLabel value={1} control={<Radio />} label={t('ManDownUponInclination')} />
                        <Box textAlign="">
                            <TextField name="TiltAngle"  margin="normal"
                                style={{width: '100%'}}
                                label={this.state.errors.TiltAngle ? t('TiltAngle') + ': ' + this.state.errors.TiltAngle:t('TiltAngle')}
                                autoComplete="off"
                                error={this.state.errors.TiltAngle!==false}
                                value={this.state.profile.Profile.TiltAngle}
                                onChange={this.handleInputProfile}
                            />
                        </Box>

                    </RadioGroup>
                </FormControl>


                </ExpansionPanelDetails>
        </ExpansionPanel>


        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditProfileDialog = withTranslation()(EditProfileDialog_);